import { ProfileLinkType } from "@scrile/api-provider/dist/api/ProfileLinksProvider";
import { $t } from "@/lib/i18nHelpers";
import { FormField } from "@/types";

export enum ProfileFileType {
  AVATAR = "avatar",
  AVATAR_VERIFICATION = "avatar_verification",
  BACKGROUND = "background_image",
  BACKGROUND_VERIFICATION = "background_verification",
}

export interface IFileUploadingType {
  loading: boolean;
  type?: ProfileFileType;
}

export const linkFields: FormField[] = [
  {
    name: ProfileLinkType.EMAIL,
    label: $t("Email"),
    appendIcon: "sci-chat",
    type: "email",
    fieldMeta: {
      site: "mailto:",
    },
  },
  {
    name: ProfileLinkType.WHATSAPP,
    label: $t("WhatsApp"),
    appendIcon: "sci-social-whatsapp",
    fieldMeta: {
      site: "https://wa.me/",
      regExp: /(?:(?:https?:\/\/)?.*wa\.me\/)?([^/?]+)/,
    },
  },
  {
    name: ProfileLinkType.TELEGRAM,
    label: $t("Telegram"),
    appendIcon: "sci-social-telegram",
    fieldMeta: {
      site: "https://t.me/",
      regExp: /(?:(?:https?:\/\/)?.*t\.me\/)?([^/?]+)/,
      replaceRegExp: /@/g,
    },
  },
  {
    name: ProfileLinkType.FACEBOOK,
    label: $t("Facebook"),
    appendIcon: "sci-social-facebook",
    fieldMeta: {
      site: "https://facebook.com/",
      regExp: /(?:(?:https?:\/\/)?.*facebook\.com\/)?([^/?]+)/,
    },
  },
  {
    name: ProfileLinkType.TWITTER,
    label: $t("X (ex. Twitter)"),
    appendIcon: "sci-social-x",
    fieldMeta: {
      site: "https://twitter.com/",
      regExp: /(?:(?:https?:\/\/)?.*twitter\.com\/)?([^/?]+)/,
    },
  },
  {
    name: ProfileLinkType.INSTAGRAM,
    label: $t("Instagram"),
    appendIcon: "sci-social-instagram",
    fieldMeta: {
      site: "https://instagram.com/",
      regExp: /(?:(?:https?:\/\/)?.*instagram\.com\/|@?)?([^/?]+)/,
    },
  },
  {
    name: ProfileLinkType.YOUTUBE,
    label: $t("YouTube"),
    appendIcon: "sci-social-youtube",
    fieldMeta: {
      site: "https://youtube.com/",
      regExp: /(?:(?:https?:\/\/)?.*youtube\.com\/)?([^*]+)/,
    },
  },
  {
    name: ProfileLinkType.TIKTOK,
    label: $t("TikTok"),
    appendIcon: "sci-social-tiktok",
    fieldMeta: {
      site: "https://tiktok.com/@",
      regExp: /(?:(?:https?:\/\/)?.*tiktok\.com\/@)?([^/?]+)/,
    },
  },
  {
    name: ProfileLinkType.SNAPCHAT,
    label: $t("Snapchat"),
    appendIcon: "sci-social-snapchat",
    fieldMeta: {
      site: "https://snapchat.com/add/",
      regExp: /(?:(?:https?:\/\/)?.*snapchat\.com\/add\/)?([^/?]+)/,
    },
  },
  {
    name: ProfileLinkType.PATREON,
    label: $t("Patreon"),
    appendIcon: "sci-social-patreon",
    fieldMeta: {
      site: "https://patreon.com/",
      regExp: /(?:(?:https?:\/\/)?.*patreon\.com\/)?([^/?]+)/,
    },
  },
  {
    name: ProfileLinkType.ONLYFANS,
    label: $t("OnlyFans"),
    appendIcon: "sci-social-onlyfans",
    fieldMeta: {
      site: "https://onlyfans.com/",
      regExp: /(?:(?:https?:\/\/)?.*onlyfans\.com\/|@?)?([^/?]+)/,
    },
  },
  {
    name: ProfileLinkType.LINKEDIN,
    label: $t("LinkedIn"),
    appendIcon: "sci-social-linkedin",
    fieldMeta: {
      site: "https://linkedin.com/in/",
      regExp: /(?:(?:https?:\/\/)?.*linkedin\.com\/in\/)?([^/?]+)/,
    },
  },
].map(i => ({ ...i, appendIconColor: "var(--palette-gray)" }));
